'use client'
import { usePathname } from 'next/navigation'
import React, { Dispatch, ReactNode, SetStateAction, createContext, useMemo, useState } from 'react'

import { ToastDialog } from '@/components'
import { TToastDialog } from '@/components/shared/toast-dialog'

export interface TToastDialogContext extends TToastDialog {
  setState?: Dispatch<SetStateAction<TToastDialogContext>>
}

export const ToastDialogContext = createContext<TToastDialogContext | null>(null)

export const defaultToastDialogState: TToastDialogContext = {
  show: false,
  type: 'success',
  title: '',
  description: '',
  traceId: '',
  disableClose: false,
  onClose: undefined,
}

const ToastDialogProvider = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname()
  const [state, setState] = useState<TToastDialogContext>(defaultToastDialogState)

  const value: TToastDialogContext = useMemo(
    () => ({
      ...state,
      setState,
    }),
    [state, setState],
  )

  return (
    <ToastDialogContext.Provider value={value}>
      {children}
      {state.show && pathname !== '/suspend' ? <ToastDialog {...state} positionBottom /> : null}
    </ToastDialogContext.Provider>
  )
}

export default ToastDialogProvider
